module.exports = __webpack_public_path__ + "static/media/it.e4b22d96.svg";